const Footer = () => {
    return (
        <footer className="bg-neutral-900 text-center py-6 text-sm text-white-500 mt-5">
            <p>
                ©  {new Date().getFullYear()} Autodesk, Inc. | Disclaimer: This application utilizes AutodeskGPT 
            </p>
        </footer>
    )
}


export default Footer;